import type { Work } from '@/features/veluvit/types/api.types'

export type SpeakerIdentity = {
  speaker?: string | null
  speakerId?: string | null
  speakerType?: string
}
export type ChatSpeakerProfile = {
  name: string
  image: string
  avatar: string
  role: string
}
type Fallback = { name?: string; image?: string; avatar?: string }

/** 작품 ID와 출연 캐릭터 ID는 다르다. 명시된 화자 ID를 우선하고, 옛 메시지만 이름으로 연결한다. */
export function resolveChatSpeaker(
  workId: string,
  work: Work | undefined,
  identity: SpeakerIdentity = {},
  fallback: Fallback = {}
): ChatSpeakerProfile {
  const { speaker, speakerId, speakerType } = identity
  const cast = work?.cast ?? []
  const lead = cast[0]
  const unknown = {
    name: speaker || speakerId || '인물',
    image: '',
    avatar: '',
    role: '',
  }
  // 생성된 주변 인물이 등록 캐릭터와 이름이 같아도 사진을 빌려 쓰지 않는다.
  if (speakerType === 'npc') return unknown
  const person = speakerId
    ? (cast.find((person) => person.id === speakerId) ??
      (speakerId === workId ? lead : undefined))
    : (cast.find((person) => person.name === speaker) ??
      (!speaker || speaker === work?.name || speaker === fallback.name
        ? lead
        : undefined))
  const legacyLead =
    !person &&
    (!speakerId || speakerId === workId) &&
    (!speaker || speaker === work?.name || speaker === fallback.name)
  if (!person && !legacyLead) return unknown
  const isLead = !person || person === lead
  const image =
    person?.image?.trim() ||
    (isLead ? fallback.image || work?.image?.trim() || '' : '')
  const avatar =
    person?.avatar?.trim() ||
    (isLead ? work?.images?.avatar?.trim() : '') ||
    (!person ? fallback.avatar : '') ||
    image
  return {
    name: person?.name || fallback.name || work?.name || '캐릭터',
    image,
    avatar,
    role: person?.role || '',
  }
}
